<template>
  <main-template>
    <v-row class="align-center mt-2 mb-2">
      <v-col>
        <div class="d-flex align-center">
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon>fa fa-angle-left</v-icon>
          </v-btn>
          <div class="ml-1">
            <h1 class="mb-0" style="line-height: 1.2;">Censos Escolares</h1>
          </div>
        </div>
      </v-col>
      <v-col cols="auto">
        <v-btn color="primary" @click="dialog = true">
          <v-icon left small>fa fa-plus</v-icon>
          Novo Censo
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <resumo-card
        v-for="card in resumo"
        :key="card.label"
        :label="card.label"
        :valor="card.valor"
        :icone="card.icone"
        :cor="card.cor"
        :cor-fundo="card.corFundo"
        :loading="loading"
      />
    </v-row>

    <v-row class="mt-4">
      <v-col>
        <v-data-table
          :headers="headers"
          :items="censos"
          :loading="loading"
          class="rounded-xl"
          outlined
        >
          <template #[`item.finalizado`]="{ item }">
            <v-chip small :color="item.finalizado ? 'green' : 'orange'" dark>
              {{ item.finalizado ? "Finalizado" : "Em Aberto" }}
            </v-chip>
          </template>

          <template #[`item.acoes`]="{ item }">
            <v-btn icon small @click="verCenso(item)">
              <v-icon small>fa fa-edit</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <base-dialog
      v-model="dialog"
      title="Novo Censo"
      :loading="salvando"
      @confirm="salvarCenso"
    >
      <v-text-field v-model="form.descricao" label="Descrição" outlined dense />
      <v-select
        v-model="form.ano_id"
        :items="anos"
        item-text="ano"
        item-value="id"
        label="Ano"
        outlined
        dense
      />
    </base-dialog>
  </main-template>
</template>

<script>
import ResumoCard from "@/components/CensoEscolar/ResumoCard.vue";
import BaseDialog from "@/components/EDialog.vue";

export default {
  components: { ResumoCard, BaseDialog },

  data() {
    return {
      censos: [],
      anos: [],
      loading: true,
      salvando: false,
      dialog: false,
      form: { descricao: "", ano_id: null },
      headers: [
        { text: "Descrição", value: "descricao" },
        { text: "Ano", value: "ano.ano" },
        { text: "Status", value: "finalizado" },
        { text: "Ações", value: "acoes", sortable: false, align: "center" },
      ],
    };
  },

  computed: {
    resumo() {
      return [
        { label: "TOTAL", valor: this.censos.length, icone: "fa fa-list", cor: "primary", corFundo: "#e8f0fe" },
        { label: "EM ABERTO", valor: this.censos.filter((c) => !c.finalizado).length, icone: "fa fa-clock", cor: "orange darken-2", corFundo: "#fff3e0" },
        { label: "FINALIZADOS", valor: this.censos.filter((c) => c.finalizado).length, icone: "fa fa-check-circle", cor: "green darken-1", corFundo: "#e8f5e9" },
        { label: "FINALIZADOS", valor: this.censos.filter((c) => c.finalizado).length, icone: "fa fa-check-circle", cor: "green darken-1", corFundo: "#e8f5e9" },
      ];
    },
  },

  methods: {
    fecharDialog() {
      this.dialog = false;
      this.form = { descricao: "", ano_id: null };
    },

    async salvarCenso() {
      this.salvando = true;
      try {
        await this.$services.censoService.store(this.form);
        this.censos = await this.$services.censoService.index();
        this.fecharDialog();
        this.$toast.success("Censo criado com sucesso!");
      } catch (e) {
        this.$toast.error("Erro ao criar censo.");
      } finally {
        this.salvando = false;
      }
    },

    verCenso(censo) {
      this.$router.push({ name: "censo-escolar-show", params: { id: censo.id } });
    },
  },

  async created() {
    [this.censos, this.anos] = await Promise.all([
      this.$services.censoService.index(),
      this.$services.anosService.syncAll(),
    ]);
    this.loading = false;
  },
};
</script>